import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
const h = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const STATUS_COLOR = {
  active: '#10b981', trial: '#f59e0b', expired: '#ef4444', suspended: '#6b7280',
};
const STATUS_LABEL = {
  active: 'Faol', trial: 'Trial', expired: 'Muddati o\'tgan', suspended: 'To\'xtatilgan',
};

export default function SuperSubscriptions() {
  const [subs, setSubs] = useState([]);
  const [total, setTotal] = useState(0);
  const [statusFilter, setStatusFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [activating, setActivating] = useState(null);
  const [msg, setMsg] = useState('');

  const load = useCallback(() => {
    setLoading(true);
    axios.get(`${API}/super/subscriptions`, { ...h(), params: { status: statusFilter } })
      .then(r => { setSubs(r.data.subscriptions); setTotal(r.data.total); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [statusFilter]);

  useEffect(() => { load(); }, [load]);

  const activate = async (ownerId, labName) => {
    const months = prompt(`${labName} uchun necha oy faollashtirish?`, '1');
    if (!months) return;
    const m = parseInt(months);
    if (!m || m < 1) return;
    setActivating(ownerId);
    try {
      await axios.post(`${API}/super/subscriptions/${ownerId}/activate`, { months: m }, h());
      setMsg(`${labName} — ${m} oylik obuna faollashtirildi`);
      load();
    } catch (e) {
      setMsg(e.response?.data?.error || 'Xatolik');
    }
    setActivating(null);
  };

  return (
    <div style={{ maxWidth: 1100 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <div style={{ fontSize: 20, fontWeight: 900, color: '#f59e0b' }}>📋 Obunalar</div>
          <div style={{ fontSize: 12, color: 'var(--text3)' }}>Jami: {total} ta</div>
        </div>
      </div>

      {msg && (
        <div style={{ padding: '12px 16px', borderRadius: 10, marginBottom: 16, background: 'rgba(16,185,129,0.1)', border: '1px solid #10b981', color: '#10b981', display: 'flex', justifyContent: 'space-between' }}>
          {msg}
          <button onClick={() => setMsg('')} style={{ background: 'none', border: 'none', color: '#10b981', cursor: 'pointer' }}>✕</button>
        </div>
      )}

      {/* Status filter */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {[['', 'Barchasi'], ['active', 'Faol'], ['trial', 'Trial'], ['expired', 'Muddati o\'tgan'], ['suspended', 'To\'xtatilgan']].map(([val, label]) => (
          <button key={val} onClick={() => setStatusFilter(val)} style={{
            padding: '7px 16px', borderRadius: 20, cursor: 'pointer', fontWeight: 700, fontSize: 12,
            background: statusFilter === val ? 'rgba(245,158,11,0.2)' : 'var(--bg2)',
            border: `1px solid ${statusFilter === val ? '#f59e0b' : 'var(--border)'}`,
            color: statusFilter === val ? '#f59e0b' : 'var(--text2)',
          }}>{label}</button>
        ))}
      </div>

      <div style={{ background: 'var(--bg2)', borderRadius: 14, border: '1px solid var(--border)', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid var(--border)' }}>
              {['Klub', 'Egasi', 'Status', 'Reja', 'Boshlanish', 'Tugash', 'Amal'].map(col => (
                <th key={col} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, color: 'var(--text3)', fontWeight: 700, textTransform: 'uppercase' }}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ textAlign: 'center', padding: 40, color: 'var(--text3)' }}>Yuklanmoqda...</td></tr>
            ) : subs.length === 0 ? (
              <tr><td colSpan={7} style={{ textAlign: 'center', padding: 40, color: 'var(--text3)' }}>Topilmadi</td></tr>
            ) : subs.map(s => (
              <tr key={s.owner_id} style={{ borderBottom: '1px solid var(--border)' }}>
                <td style={{ padding: '12px 16px', fontWeight: 700 }}>{s.lab_name}</td>
                <td style={{ padding: '12px 16px', fontSize: 13, color: 'var(--text2)' }}>
                  {s.owner_name}<br />
                  <span style={{ fontSize: 11, color: 'var(--text3)' }}>{s.owner_email}</span>
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <span style={{
                    padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700,
                    background: (STATUS_COLOR[s.status] || '#6b7280') + '22',
                    color: STATUS_COLOR[s.status] || '#6b7280',
                  }}>{STATUS_LABEL[s.status] || s.status}</span>
                </td>
                <td style={{ padding: '12px 16px', fontSize: 13, color: 'var(--text2)' }}>{s.plan || '—'}</td>
                <td style={{ padding: '12px 16px', fontSize: 12, color: 'var(--text3)' }}>
                  {s.starts_at ? new Date(s.starts_at).toLocaleDateString('uz-UZ') : '—'}
                </td>
                <td style={{ padding: '12px 16px', fontSize: 12, color: s.status === 'expired' ? '#ef4444' : 'var(--text3)' }}>
                  {s.ends_at ? new Date(s.ends_at).toLocaleDateString('uz-UZ') : '—'}
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <button
                    onClick={() => activate(s.owner_id, s.lab_name)}
                    disabled={activating === s.owner_id}
                    style={{
                      padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 12,
                      background: 'rgba(16,185,129,0.15)', border: '1px solid #10b981', color: '#10b981',
                    }}
                  >
                    {activating === s.owner_id ? '...' : '✅ Faollashtir'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
